import { AudioEngineRemoteAudio, P2pRemoteAudio, SfuRemoteAudio } from '@/RoomContext'
import { MusePeer } from '@/services/RoomContextMusePeer'
import { AudioDevicePeer } from './AudioDevice/AudioDevicePeer'
import { cn } from '@/utlis/cn'
import { cardXPad } from './UserCard'
import { remoteAudioSettingsEvent } from '@/pages/RemoteAudioSettings/RemoteAudioSettingsDialogController'

type AudioDevicePanelPeerProps = {
    peer: MusePeer
}
export function AudioDevicePanelPeer(props: AudioDevicePanelPeerProps) {
    const isAudioDeprioritized = props.peer.manifest?.isAudioDeprioritized ?? false
    if (isAudioDeprioritized) {
        return (
            <div className={cn('font-normal text-muse-fg/50 text-sm', cardXPad)}>
                Offloaded to save resources because the user has been silent
            </div>
        )
    }
    return (
        <div className="flex flex-col pb-1">
            {props.peer.remoteAudios.map((media: P2pRemoteAudio | SfuRemoteAudio | AudioEngineRemoteAudio) => {
                const streamId =
                    media.fromTopology === 'ae' ? media.info.audioEngineStreamUuid || '' : media.stream?.id || ''
                const key = streamId + '_' + (media.info.deviceId || '')
                return (
                    <AudioDevicePeer
                        key={key}
                        peer={props.peer}
                        media={media}
                        onShowDeviceSettingsDialog={(peer, media) => remoteAudioSettingsEvent.open({ peer, media })}
                    />
                )
            })}
            {props.peer.remoteAudios.length === 0 && (
                <div className={cn('font-light opacity-65', cardXPad)}>No audio devices shared</div>
            )}
        </div>
    )
}
